import React from 'react';
import styled from 'styled-components';
import KubitTooltip from '../../components/KubitTooltip';

interface IProps {
  children: React.ReactNode;
  isPermitted: boolean;
  /**
   * Special case for SingleSelectOption, KubitTooltip must wrap with parent element,
   * But ActionsMenu required to be direct child of Dropdown.Menu,
   * Therefore manually set up opacity for SingleSelectOption
   */
  isHalfOpacity?: boolean;
  customTooltip?: string;
}

const NonPermittedElementContainer = styled.div<{ $isHalfOpacity?: boolean }>`
  opacity: ${({ $isHalfOpacity }) => ($isHalfOpacity ? 0.5 : 1)};
`;

/**
 * This component is used to wrap elements that need to be disabled when user doesn't have permission
 * @param children - the element that need to be disabled or displayed
 * @param isHalfOpacity - whether to display the element with half opacity as special case
 * @param offset - the offset of the text popup
 * @param isPermitted - whether the user has permission to display the element
 * @param customTooltip - the custom tooltip content
 */
const PermissionElementWrapper = ({
  children,
  isHalfOpacity,
  isPermitted,
  customTooltip = "You don't have permission to do this.",
}: IProps) => {
  return isPermitted ? (
    <>{children}</>
  ) : (
    <KubitTooltip content={customTooltip} noOpenDelay={true}>
      <NonPermittedElementContainer $isHalfOpacity={isHalfOpacity}>
        {children}
      </NonPermittedElementContainer>
    </KubitTooltip>
  );
};

export default PermissionElementWrapper;
